/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckylotteryitemscustem.vue?vue&type=template&id=136110e4&scoped=true"
import script from "./luckylotteryitemscustem.vue?vue&type=script&lang=js"
export * from "./luckylotteryitemscustem.vue?vue&type=script&lang=js"
import style0 from "./luckylotteryitemscustem.vue?vue&type=style&index=0&id=136110e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136110e4",
  null
  
)

export default component.exports